import React, { useState } from "react";
import faqimage from "../../assets/images/contact.svg";

const faqs = [
  {
    question: "How do I post a job?",
    answer:
      "Log in to your employer account, click 'Post a Job', fill in job details and submit.",
  },
  {
    question: "How can students search for jobs?",
    answer:
      "Visit the Jobs page and use filters like category, location, or type to find jobs.",
  },
  {
    question: "Are there any charges to post a job?",
    answer:
      "We offer both free and premium job listings. Premium listings gain higher visibility.",
  },
  {
    question: "Can students apply through this portal?",
    answer:
      "Yes, students can apply by clicking on 'Apply Now' on the job listing.",
  },
  {
    question: "How can employers track applications?",
    answer:
      "Employers can view all applications in the 'Applications' tab of their dashboard.",
  },
  {
    question: "How long for a job listing to get approved?",
    answer:
      "Free listings are reviewed within 24–48 hours. Premium listings are approved instantly.",
  },
];

const JobPortalFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-gray-50 py-20 px-6 sm:px-10 md:px-20">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
        {/* Left - FAQs */}
        <div>
          <h5 className="text-sm text-[#345bf3] font-medium tracking-wide uppercase mb-3">
            FAQs
          </h5>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#fc3c04] mb-10 leading-tight">
            Frequently Asked <span className="text-[#345bf3]">Questions</span> 
          </h2>

          <div className="space-y-8">
            {faqs.map((item, index) => (
              <div
                key={index}
                className="border-b pb-6 border-gray-300"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex justify-between items-start text-left group"
                >
                  <span className="flex gap-3 text-lg sm:text-xl font-semibold text-gray-800 group-hover:text-[#345bf3]">
                    <span className="text-2xl text-[#345bf3]">
                      {openIndex === index ? "−" : "+"}
                    </span>
                    {item.question}
                  </span>
                </button>
                {openIndex === index && (
                  <p className="mt-4 text-gray-600 text-base leading-relaxed pl-9 pr-2">
                    {item.answer}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Right - Image */}
        <div className="flex justify-center items-center">
          <img
            src={faqimage}
            alt="Job Portal FAQ"
            className="w-full max-w-md object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default JobPortalFAQ;
